import React from 'react';
import PropTypes from "prop-types";

import FractionInput from './FractionInput';


function IntegerPart({itemData, component_data, is_preview, answer, existing_answer, onChange, fractionKey}) {
    const renderInput = (fieldKey) => {
        const fieldData = _.get(itemData, ['inputs', fieldKey]);
        return (
            <FractionInput
                component_data={component_data}
                is_preview={is_preview}
                answer={answer}
                existing_answer={existing_answer}
                onChange={onChange(fieldKey)}
                fieldData={fieldData}
                fieldKey={fieldKey}
                fractionKey={fractionKey}
            />
        );
    }

    const fractionStyle = _.get(itemData, 'style');

    return (
        <div className="cc-fraction-fractionpart" style={fractionStyle}>
            <div className="flex-row flex-v-center">
                {renderInput("v")}
            </div>
        </div>
    );
}

IntegerPart.propTypes = {
    itemData: PropTypes.object.isRequired,
    component_data: PropTypes.object.isRequired,
    answer: PropTypes.object.isRequired,
    existing_answer: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    fractionKey: PropTypes.number.isRequired
}

export default IntegerPart
